import script from "./TwoFaPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFaPopup.vue?vue&type=script&setup=true&lang=js"

import "./TwoFaPopup.vue?vue&type=style&index=0&id=ca337704&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca337704"]])

export default __exports__